import BaseAdapter from './base';
import KNBAdapter from './knb';
import WxAdapter from './weixin';

// 注册默认适配器
const Adapters = [KNBAdapter(BaseAdapter), WxAdapter(BaseAdapter), BaseAdapter];
class AdapterManager {
  /**
     * 注册adapter
     * @param { BaseAdapter } adapter
     */
  static add(AdapterWrap) {
    Adapters.unshift(AdapterWrap(BaseAdapter));
  }

  static getAdapter() {
    return Promise.all(Adapters.map(Adp => Adp.canUse()))
      .then(results => Adapters[results.findIndex(v => !!v)])
      .then(Adp => Adp.load().then(sdk => new Adp(sdk)));
  }
}
export default AdapterManager;
